import { defaultSurfStyle } from "../model/defaultStyle.js";
import { defaultArtDirection } from "./artDirection.js";
import { DEFAULT_PULSE_PRESET_ID, getPulsePreset, PULSE_PRESET_CATALOG, } from "./pulsePresetsCatalog.js";
import { mergeSurfStyle } from "./surfStyle.js";
export function defaultStyleAspects() {
    return {
        injectDerivedPromptInImagePrompt: true,
        injectPaletteInPrompt: true,
        injectBackgroundPalette: true,
        injectTextPalette: true,
        useImagePixelReference: false,
    };
}
function catalogToPreset(entry) {
    return {
        id: entry.id,
        title: entry.name,
        description: entry.prePrompt.slice(0, 120),
        prePrompt: entry.prePrompt,
        emoji: entry.emoji,
        realism: entry.realism,
    };
}
export const SURF_STYLE_PRESETS = PULSE_PRESET_CATALOG.map(catalogToPreset);
export function getSurfStylePreset(id) {
    return SURF_STYLE_PRESETS.find((p) => p.id === id);
}
export function deckCompositionMode(theme) {
    return theme.composition ?? "composed-background";
}
export function isComposedBackgroundMode(theme) {
    return deckCompositionMode(theme) === "composed-background";
}
export function styleFromPreset(presetId, presentationType) {
    const preset = getPulsePreset(presetId);
    if (!preset)
        throw new Error(`Preset stile sconosciuto: ${presetId}`);
    const base = defaultSurfStyle();
    return mergeSurfStyle(base, {
        selectedPresetId: preset.id,
        backgroundTreatment: preset.prePrompt,
        backgroundRealism: preset.realism,
        artDirection: defaultArtDirection(preset.realism),
        composition: "composed-background",
        styleAspects: defaultStyleAspects(),
        presentationType: presentationType?.trim() || base.presentationType,
    });
}
export function styleFromPresetOrDefault(presetId, presentationType) {
    return styleFromPreset(presetId?.trim() || DEFAULT_PULSE_PRESET_ID, presentationType);
}
